import { Controller } from '@hotwired/stimulus'
import SupervisedPersonController from './supervised-person'

// Connects to data-controller="finfolio-select"
export default class FinfolioSelectController extends Controller {
  // Declarations for targets
  declare readonly accountNumberSelectTarget: HTMLSelectElement

  // Declarations for outlets
  declare readonly supervisedPersonOutlet: SupervisedPersonController
  declare readonly hasSupervisedPersonOutlet: boolean

  // Declarations for target presence checks
  declare readonly hasAccountNumberSelectTarget: boolean

  static targets = ['accountNumberSelect']

  static outlets = ['supervised-person']

  // Depending on the permission type, the supervised person field can be a select or text
  updateSupervisedPerson() {
    // Not every submission view has a Rep Code field to fill
    if (!this.hasSupervisedPersonOutlet) return

    const selectedOption = this.accountNumberSelectTarget.selectedOptions[0]
    const repCode = selectedOption.dataset.repCode
    const managerName = selectedOption.dataset.managerName

    if (this.supervisedPersonOutlet.hasRepCodeSelectTarget) {
      this.supervisedPersonOutlet.updateSelectField(repCode)
    } else if (this.supervisedPersonOutlet.hasRepCodeDisplayTarget) {
      this.supervisedPersonOutlet.updateHiddenField(managerName, repCode)
    } else {
      console.warn('FinfolioSelectController: No valid target found for updating manager rep code.')
    }
  }
}
